import { clientActionSubscribe, clientActionUnsubscribe, EntityTypeEnum, FilterOperation, SubscribeType, SubscriptionIdentifier } from 'api'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createEntitySubscriptionFiltersSelector } from 'selectors/selectionSelectors'
import { isNotEmpty } from 'utils/predicate'

const subscriptionFilterSelector = createEntitySubscriptionFiltersSelector(
  () => EntityTypeEnum.COLLATERAL_DETAILS,
  () => SubscriptionIdentifier.COLLATERAL_DETAILS
)

export const useSubscribeToCollateralDetails = () => {
  const dispatch = useDispatch()
  const currentSubscriptionFilter = useSelector(subscriptionFilterSelector)[0]

  const subscribeToCollateralDetails = useCallback(
    (collateralId: string | null) => {
      const collateralIds =
        currentSubscriptionFilter?.value && collateralId ? collateralId.concat(',', currentSubscriptionFilter.value) : collateralId
      dispatch(
        clientActionSubscribe({
          entityTypeEnum: EntityTypeEnum.COLLATERAL_DETAILS,
          preDefinedFilter: null,
          filters: [
            {
              andFilter: null,
              fieldName: 'id',
              filterOperation: FilterOperation.CONTAINS,
              orFilter: null,
              value: collateralIds,
              calculatedValueType: null
            }
          ],
          postTransformFilters: [],
          subscribeType: SubscribeType.FILTERED,
          subscriptionIdentifier: SubscriptionIdentifier.COLLATERAL_DETAILS,
          limitResults: false,
          pageSize: null,
          pageNumber: null,
          summaryRequest: null
        })
      )
    },
    [currentSubscriptionFilter, dispatch]
  )

  const unsubscribeFromCollateralDetails = useCallback(
    (collateralId: string | null) => {
      const currentCollateralIds = currentSubscriptionFilter?.value ? currentSubscriptionFilter.value : null
      const remainingCollateralIds =
        typeof currentCollateralIds === 'string' && collateralId ? currentCollateralIds.replace(collateralId, '') : null
      if (isNotEmpty(remainingCollateralIds)) {
        dispatch(
          clientActionSubscribe({
            entityTypeEnum: EntityTypeEnum.COLLATERAL_DETAILS,
            preDefinedFilter: null,
            filters: [
              {
                andFilter: null,
                fieldName: 'id',
                filterOperation: FilterOperation.CONTAINS,
                orFilter: null,
                value: remainingCollateralIds,
                calculatedValueType: null
              }
            ],
            postTransformFilters: [],
            subscribeType: SubscribeType.FILTERED,
            subscriptionIdentifier: SubscriptionIdentifier.COLLATERAL_DETAILS,
            limitResults: false,
            pageSize: null,
            pageNumber: null,
            summaryRequest: null
          })
        )
      } else {
        dispatch(
          clientActionUnsubscribe({
            entityTypeEnum: EntityTypeEnum.COLLATERAL_DETAILS,
            subscriptionIdentifier: SubscriptionIdentifier.COLLATERAL_DETAILS
          })
        )
      }
    },
    [currentSubscriptionFilter, dispatch]
  )

  return { subscribeToCollateralDetails, unsubscribeFromCollateralDetails }
}
